module.exports = __webpack_public_path__ + "static/img/icon6.93662f64.png";